import React from "react";


import imageOne from "../../resource/talks/ourteacher/inside/2.png";
import imageThree from "../../resource/talks/ourteacher/inside/3.png";
import imageTwo from "../../resource/talks/ourteacher/inside/4.png";
import imageSeven from "../../resource/talks/ourteacher/inside/5.png";

import imageFour from "../../resource/talks/ourteacher/inside/6.png";
import TitleChnage from "../../Hook/TitleChnage";
import imageFive from "../../resource/talks/ourteacher/5.png";
import banner from "../../resource/talks/ourteacher/inside/7.jpeg";

const VariousTeachersTalks = () => {
    TitleChnage("Our Teahcer");

  return (
    <div className="dmmatalkVteahcerT-page inside-pages">
    <div className="right-box">
      <img
        src={imageOne}
        alt="Right Top Image"
        className="right-image"
        width={300}
      />
    </div>

    <h1 className="font-main  p-4 mt-4">Dhamma Talks</h1>

   

   

    <p className="h4 mt-5 p-4 ">
      If you know the details of the Dhamma sermon or the Retreat of interest,
      please use the following search buttons to refine your criteria.
    </p>

    <div className="form-box mt-5 p-4">
      <p className="h4  ">Sutta Name (Title)</p>
      <div className="form-item">
        <input type="text" />
      </div>
    </div>

    <div className="form-box mt-5 p-4">
      <p className="h4  ">Event Title</p>
      <div className="form-item">
        <input type="text" />
      </div>
    </div>

    <div className="form-box mt-5 p-4">
      <p className="h4  ">Retreat No (Event No)</p>
      <div className="form-item">
        <input type="text" />
      </div>
    </div>

    <div className="form-box mt-5 p-4">
      <p className="h4  ">Event Location</p>
      <div className="form-item">
        <input type="text" />
      </div>
    </div>

    <div className="form-box mt-5 p-4">
      <p className="h4  ">Event Start Date</p>
      <div className="form-item">
        <input type="date" />
      </div>
    </div>

    <div className="form-box mt-5 p-4">
      <p className="h4  ">Event End Date</p>
      <div className="form-item">
        <input type="date" />
      </div>
    </div>

    <div className="formbtn p-4 mt-5">
      <button type="reset">CLEAR</button>
      <button type="submit">SEARCH</button>
    </div>

    <p className="h4 mt-5 p-4 ">
      Alternatively, you may choose from the following three categories to
      expore a comprehensive list of events or individual events 
    </p>

   

    <div className="btn-group3 mt-6">
      <img
        src={imageTwo}
        alt="Right Top Image"
        width={300}
        className="curser-pointer"
        id="internalRules"
      />
      <img
        src={imageSeven}
        alt="Right Top Image"
        width={300}
        className="curser-pointer"
        id="internalRetreatForm"
      />
      <img
        src={imageFour}
        alt="Right Top Image"
        width={300}
        className="curser-pointer"
        id="internalRetreatForm"
      />
    </div>

    <p className="font-second mt-6 p-4 text-center ">"Sunatha Dharetha Charatha Dhamme"</p>
    <p className="h4 mt-5 p-4 text-center ">Listen deeply, maintain its wisdom, and practice its path</p>

    <div className="bottom-box mt-6">
      <img src={imageThree} alt="bottom-image" width={600} />
    </div>
  </div>
  )
}

export default VariousTeachersTalks